export default __webpack_public_path__ + "static/media/AutoAgentsAllocation_1.7bf3e3c6.svg";